/**
 * 项目物料页面（MPM v5.0.0 改为双页签）
 *
 * 1. 【我提报的】：原项目物料页面原样迁入，数据、筛选、操作不变（PRD REQ-SCP-TAB-001 BR-01）
 * 2. 【项目商品池】：当前服务商已关联且获得 SCP服务商 授权的项目物料（BR-02 两个页签数据隔离）
 *
 * 【项目商品池】首次选中才加载，之后切换页签保持挂载；从其他页面切回来时恢复离开前的页签与物料池状态
 *（用户 2026-10-13，覆盖 PRD BR-12“退出后恢复默认卡片”）。页面缓存随页面页签关闭而清除。
 */
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Tabs } from 'antd'
import { usePageCache } from '@/tools/utilHooks'
import MyReport from './components/MyReport'
import ProjectPool from './components/ProjectPool'
import Style from './style.module.scss'

const TAB_MY_REPORT = 'myReport'
const TAB_PROJECT_POOL = 'projectPool'

const ProjectMaterial = () => {
  const { pathname } = useLocation()
  const { setCacheWithKey, getCacheWithKey } = usePageCache()
  // 有本路由缓存说明是从其他页面切回来的；新打开（缓存已随页签关闭清除）则全部从默认开始
  const [pageCache] = useState<{ activeTab: string } | null>(() =>
    getCacheWithKey(pathname),
  )
  const [activeTab, setActiveTab] = useState(
    pageCache?.activeTab || TAB_MY_REPORT,
  )
  const [poolVisited, setPoolVisited] = useState(activeTab === TAB_PROJECT_POOL)

  const changeTab = (key: string) => {
    setActiveTab(key)
    if (key === TAB_PROJECT_POOL) setPoolVisited(true)
  }

  const saveTabCache = () => setCacheWithKey({ activeTab }, pathname)

  useEffect(() => {
    saveTabCache()
  }, [activeTab])

  return (
    <div className={Style['container']}>
      <Tabs
        type="card"
        activeKey={activeTab}
        onChange={changeTab}
        items={[
          { key: TAB_MY_REPORT, label: '我提报的', children: <MyReport /> },
          {
            key: TAB_PROJECT_POOL,
            label: '项目商品池',
            children: poolVisited ? (
              <ProjectPool
                restore={Boolean(pageCache)}
                active={activeTab === TAB_PROJECT_POOL}
              />
            ) : null,
          },
        ]}
      />
    </div>
  )
}

export default ProjectMaterial
/**
 * 项目物料页面（MPM v5.0.0 改为双页签）
 *
 * 1. 【我提报的】：原项目物料页面原样迁入，数据、筛选、操作不变（PRD REQ-SCP-TAB-001 BR-01）
 * 2. 【项目商品池】：当前服务商已关联且获得 SCP服务商 授权的项目物料（BR-02 两个页签数据隔离）
 *
 * 【项目商品池】首次选中才加载，之后切换页签保持挂载；从其他页面切回来时恢复离开前的页签与物料池状态
 *（用户 2026-10-13，覆盖 PRD BR-12“退出后恢复默认卡片”）。页面缓存随页面页签关闭而清除。
 */
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Tabs } from 'antd'
import { usePageCache } from '@/tools/utilHooks'
import MyReport from './components/MyReport'
import ProjectPool from './components/ProjectPool'
import Style from './style.module.scss'

const TAB_MY_REPORT = 'myReport'
const TAB_PROJECT_POOL = 'projectPool'

const ProjectMaterial = () => {
  const { pathname } = useLocation()
  const { setCacheWithKey, getCacheWithKey } = usePageCache()
  // 有本路由缓存说明是从其他页面切回来的；新打开（缓存已随页签关闭清除）则全部从默认开始
  const [pageCache] = useState<{ activeTab: string } | null>(() =>
    getCacheWithKey(pathname),
  )
  const [activeTab, setActiveTab] = useState(
    pageCache?.activeTab || TAB_MY_REPORT,
  )
  const [poolVisited, setPoolVisited] = useState(activeTab === TAB_PROJECT_POOL)

  const changeTab = (key: string) => {
    setActiveTab(key)
    if (key === TAB_PROJECT_POOL) setPoolVisited(true)
  }

  const saveTabCache = () => setCacheWithKey({ activeTab }, pathname)

  useEffect(() => {
    saveTabCache()
  }, [activeTab])

  return (
    <div className={Style['container']}>
      <Tabs
        type="card"
        activeKey={activeTab}
        onChange={changeTab}
        items={[
          { key: TAB_MY_REPORT, label: '我提报的', children: <MyReport /> },
          {
            key: TAB_PROJECT_POOL,
            label: '项目商品池',
            children: poolVisited ? (
              <ProjectPool
                restore={Boolean(pageCache)}
                active={activeTab === TAB_PROJECT_POOL}
              />
            ) : null,
          },
        ]}
      />
    </div>
  )
}

export default ProjectMaterial
